export const document = [
  {
    path: '/document/share',
    component: () => import(/* webpackChunkName: "documentShare" */ '@/views/document/share.vue')
  },
  {
    path: '/document/interview',
    component: () => import(/* webpackChunkName: "documentInterview" */ '@/views/document/interview.vue')
  },
  {
    path: '/document/fileCollection',
    component: () => import(/* webpackChunkName: "documentFileCollection" */ '@/views/document/fileCollection.vue')
  },
  {
    path: '/document/fileCollection/createTask',
    component: () => import(/* webpackChunkName: "documentCreateTask" */ '@/views/document/task/createTask.vue')
  },
  {
    path: '/document/fileCollection/editMember',
    component: () => import(/* webpackChunkName: "documentEditMember" */ '@/views/document/task/editMember.vue')
  },
  {
    path: '/document/fileExtraction',
    component: () => import(/* webpackChunkName: "documentFileExtraction" */ '@/views/document/fileExtraction.vue')
  },
  {
    path: '/document/portfolioReview',
    component: () => import(/* webpackChunkName: "documentPortfolioReview" */ '@/views/document/portfolioReview.vue')
  },
  {
    path: '/document/portfolioReview/createReview',
    component: () => import(/* webpackChunkName: "documentCreateReview" */ '@/views/document/portfolioReview/createReview.vue')
  }
];
